module.exports = __webpack_public_path__ + "pic/38.31b986df.png";